import { Button, Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as AddIcon } from "@king-ict/eupisi-ui/components/Icon/Add.svg";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { createOtherLegalEntityLocation, OtherLegalEntityLocation } from "../../models/ProgramRequest";
import { OtherLegalEntityInfo } from "./OtherLegalEntityInfo";
import styles from "./ProgramRequestEdit.module.scss";

export interface OtherLegalEntityInfoProps {
  name: string;
  otherLegalEntityLocations: OtherLegalEntityLocation[];
  getErrorForPath: (path: string) => string | undefined;
  onChange: (e: any) => void;
}

export function OtherLegalEntityInfos({
  name,
  otherLegalEntityLocations,
  getErrorForPath,
  onChange
}: OtherLegalEntityInfoProps) {
  const { t } = useTranslation();

  const handleOtherLegalEntityLocationChange = (event: React.ChangeEvent<any>, index: number) => {
    let newOtherLegalEntityLocationInfo = event.target.value as OtherLegalEntityLocation;
    let newList = otherLegalEntityLocations.slice();
    newList[index] = newOtherLegalEntityLocationInfo;
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  }

  const handleAdd = (event: React.MouseEvent<any, MouseEvent>) => {
    var newList = otherLegalEntityLocations.slice();
    newList.push(createOtherLegalEntityLocation());
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  };

  const handleRemove = (event: React.MouseEvent<any, MouseEvent>, index: number) => {
    var newList = otherLegalEntityLocations.slice();
    newList.splice(index, 1);
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  };

  return (
    <>
      <Row>
        <Col md={12} className={styles.rowTitleSpacing}>
          <Typography variant="smallHeading" component="h3">
            {t("request.anotherLegalEntityLocationExecutionPlaceTitle")}
          </Typography>
        </Col>
      </Row>
      {otherLegalEntityLocations &&
       otherLegalEntityLocations.length > 0 &&
       otherLegalEntityLocations.map(
        (otherLegalEntityLocation, olIndex) => {
          return (
            <Row className={styles.anotherLegalEntityLocationRow}>
              <Col md={12}>
                <div className={`${styles.anotherLegalEntityLocationSection}`}>
                  <OtherLegalEntityInfo
                    name={`otherLegalEntityLocations${olIndex}`}
                    otherLegalEntityLocation={otherLegalEntityLocation}
                    onChange={(e) => handleOtherLegalEntityLocationChange(e, olIndex)}
                    getErrorForPath={(path) => getErrorForPath(`otherLegalEntityLocations${olIndex}.${path}`)}
                  />
                  <Row>
                    <Col md={12} className="text-right">
                      <Button
                        className={`p-0 ${olIndex > 0 ? 'visible' :'invisible'}`}
                        boxless
                        disabled={otherLegalEntityLocations.length <= 1}
                        onClick={(e) => handleRemove(e, olIndex)}
                      >
                        {t("request.removeLocation")}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          );
        }
        )}
      <Row>
        <Col md={12} className={styles.addDataButtonCol}>
          <Button
            outline
            icon={<AddIcon />}
            onClick={handleAdd}
            disabled={otherLegalEntityLocations.length >= 10}
          >
            {t("request.addNewLocation")}
          </Button>
        </Col>
      </Row>
    </>
  )
}